import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeSubtitleProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The subtitle of the screen.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
  /**
   * Style variant override
   */
  variant?: "default" | "custom";
}

const ULThemeSubtitle = ({
  children,
  className,
  variant = "default",
  ...rest
}: ULThemeSubtitleProps) => {
  const themedStyles =
    "mb-4 text-body-text justify-text-header text-(length:--ul-theme-font-subtitle-size)";

  const variantOverrides = {
    default: "font-subtitle",
    custom: "font-semibold text-[#4D667B]",
  };

  const variantClasses = variant && variantOverrides[variant];

  return (
    <p className={cn(themedStyles, variantClasses, className)} {...rest}>
      {children}
    </p>
  );
};

export default ULThemeSubtitle;
